import React from "react";
import { Cartao, BotaoComTextoEIcone } from "@digix-ui/componentes";
import "./styles.scss";
import Container from "../../../componentes/Container";
import fluxoImg from "../../../assets/frameRelatorioProgramas.png";

const RelatorioProgramas: React.FC = () => {
  const ultimoEnvio = "30/09/2022 às 08:25";

  const baixarTransparencia = () => {
    window.open("/relatorios/dmf/transparencia", "_blank");
  };

  const baixarGeral = () => {
    window.open("/relatorios/dmf/relacao-geral", "_blank");
  };

  const gerarParaConstrutoras = () => {
    window.open("/relatorios/dmf/para-construtoras", "_blank");
  };

  return (
    <Container comFundo tamanhoDoContainer="grande" comCabecalhoFixo>
      <div className="dmf">
        {/* Cabeçalho */}
        <div className="dmf__header">
          <div className="dmf__title">
            <i className="far fa-house-user dmf__title-icon" aria-hidden />
            <div>
              <h1 className="dmf__heading">
                Relatórios do Desconto Moradia Financiada
              </h1>
              <p className="dmf__sub">
                Visualize todas as alterações realizadas nesse protocolo ou
                nessa pessoa.
              </p>
            </div>
          </div>

          <div className="dmf__meta">
            <span className="dmf__counter">3 relatórios</span>
            <button
              className="dmf__chevron"
              type="button"
              aria-label="Mais opções"
            >
              <i className="far fa-chevron-down" />
            </button>
          </div>
        </div>

        {/* Grid */}
        <div className="dmf__grid">
          {/* Coluna esquerda (card grande) */}
          <Cartao
            cor="secundaria"
            icone="fal fa-user-hard-hat"
            className="dmf-card dmf-card--xl"
            titulo={
              <span className="dmf-card__title">
                Relação para as construtoras
              </span>
            }
          >
            <div className="dmf-card__body">
              <p className="dmf-desc">
                Essa ação irá enviar um e-mail para cada construtora parceira do
                projeto, contendo a relação de interessados por seus respectivos
                empreendimentos e que atendam os critérios de seleção.
              </p>

              {/* “Fluxo” ilustrativo (apenas decorativo, sem imagem externa) */}
              <div className="dmf-fluxo">
                <div className="dmf-fluxo">
                  <img
                    className="dmf-fluxo-img"
                    src={fluxoImg}
                    alt="Fluxo de geração e envio de relatórios para as construtoras"
                  />
                </div>
              </div>

              <div className="dmf-card__footer">
                <BotaoComTextoEIcone
                  tipo="button"
                  cor="secundaria"
                  tamanho="pequeno"
                  icone="far fa-download"
                  posicaoDoIcone="esquerda"
                  onClick={gerarParaConstrutoras}
                  classesAuxiliares="dmf-btn"
                >
                  Gerar relatório
                </BotaoComTextoEIcone>

                <span className="dmf-last-run">
                  Último envio realizado: {ultimoEnvio}
                </span>
              </div>
            </div>
          </Cartao>

          {/* Direita — card 1 */}
          <Cartao
            cor="secundaria"
            icone="fal fa-search"
            className="dmf-card"
            titulo={
              <span className="dmf-card__title">Relação de transparência</span>
            }
          >
            <div className="dmf-card__body">
              <p className="dmf-desc">
                Relação de todos os interessados do projeto Desconto Moradia
                Financiada já enviados para as construtoras.
              </p>

              <div className="dmf-card__footer">
                <BotaoComTextoEIcone
                  tipo="button"
                  cor="secundaria"
                  tamanho="pequeno"
                  visual="contorno"
                  icone="far fa-download"
                  posicaoDoIcone="esquerda"
                  onClick={baixarTransparencia}
                  classesAuxiliares="dmf-btn dmf-btn--outline"
                >
                  Baixar relação para transparência
                </BotaoComTextoEIcone>
              </div>
            </div>
          </Cartao>

          {/* Direita — card 2 */}
          <Cartao
            cor="secundaria"
            icone="fal fa-users"
            className="dmf-card"
            titulo={<span className="dmf-card__title">Relação geral</span>}
          >
            <div className="dmf-card__body">
              <p className="dmf-desc">
                Relação de todos os interessados do projeto Desconto Moradia
                Financiada, desconsiderando os critérios de seleção.
              </p>

              <div className="dmf-card__footer">
                <BotaoComTextoEIcone
                  tipo="button"
                  cor="secundaria"
                  tamanho="pequeno"
                  visual="contorno"
                  icone="far fa-download"
                  posicaoDoIcone="esquerda"
                  onClick={baixarGeral}
                  classesAuxiliares="dmf-btn dmf-btn--outline"
                >
                  Baixar relação geral
                </BotaoComTextoEIcone>
              </div>
            </div>
          </Cartao>
        </div>
      </div>
    </Container>
  );
};

export default RelatorioProgramas;
